import { compressQuery } from '@quno/onboarding/src/data/graphql/utils/compressQuery.ts';
import { stringify } from '@quno/utils/src/json';
import type { Entry } from 'contentful-management';

export const fetchContentfulGql = async ({
  query,
  variables,
  preview = false,
}: {
  query: string;
  variables: Record<string, unknown>;
  preview?: boolean;
}): // eslint-disable-next-line @typescript-eslint/no-explicit-any
Promise<any> => {
  try {
    const res = await fetch(
      `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE}/environments/${process.env.CONTENTFUL_ENVIRONMENT}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${
            preview
              ? process.env.CONTENTFUL_PREVIEW
              : process.env.CONTENTFUL_ACCESS_TOKEN
          }`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: compressQuery(query),
          variables,
        }),
      },
    );

    const result = await res.json();
    return result;
  } catch (error) {
    console.error(stringify(error as Error));
  }
};

export type ArchiveAction = 'archived' | 'unarchived';

export const unarchiveEntry = async (entry: Entry): Promise<'unarchived'> => {
  if (entry.isPublished()) {
    await entry.unpublish();
  }

  await entry.unarchive();
  return 'unarchived';
};

export const archiveEntry = async (entry: Entry): Promise<'archived'> => {
  if (entry.isPublished()) {
    await entry.unpublish();
  }

  await entry.archive();
  return 'archived';
};

export const archiveAndUnarchieveEntry = async (
  entry: Entry,
): Promise<ArchiveAction> => {
  if (!entry.isArchived()) {
    return await archiveEntry(entry);
  }

  return unarchiveEntry(entry);
};
